import LegalDocView from '../components/LegalDocView'
import { useSeoHead } from '../lib/seo'
import { pagePath } from '../lib/localizedUrl'

export default function PrivacyPage() {
  useSeoHead({
    title: 'Zásady ochrany osobních údajů | SEO Tools',
    description: 'Jak SEO Tools zpracovává a chrání vaše osobní údaje — rozsah, účel, doba uchování a vaše práva podle GDPR.',
    hreflangPath: (l) => pagePath('privacy', l),
  })
  return <LegalDocView doc="privacy" />
}
